/**
 *
 * Vue 3 migration notice:
 * File duplicated in /front-next/packages/app/src/components/custom-metadata/CustomMetadata.ts,
 * but still required here for Vue 2 dependancies.
 *
 */

import {
  CreateCustomMetadataRequestDto,
  DatasourceDto,
 } from '@/api';

export const CUSTOM_METADATA_TYPES_ICONS = {
  BOOLEAN: 'icon-toggle-outline',
  DATETIME: 'icon-calendar',
  INTEGER: 'icon-number-symbol',
  LABEL: 'icon-tag',
  STRING: 'icon-text',
  USER: 'icon-user',
  TEAM: 'icon-user-group',
} as const;
export type CustomMetadataTypesIconsEnum = keyof typeof CUSTOM_METADATA_TYPES_ICONS;

export enum AssetsTypesEnum {
  TABLE_AND_VIEW = 'TABLE_AND_VIEW',
  DASHBOARD = 'DASHBOARD',
  PIPELINE = 'PIPELINE',
  DECLARATIVE_ASSET = 'DECLARATIVE_ASSET',
  MONITOR = 'MONITOR',
}
export const AUTHORIZED_ASSETS_TYPES = Object.values(AssetsTypesEnum);

export const AUTHORIZED_ASSETS_TYPES_ICONS = {
  TABLE_AND_VIEW: 'icon-data-table',
  DASHBOARD: 'icon-chart-multiple',
  PIPELINE: 'icon-pipeline-orchestrator',
  DECLARATIVE_ASSET: 'icon-data-source-declarative',
  MONITOR: 'icon-monitor-square',
} as const;

export type AuthorizedAssetsTypesIconsEnum = keyof typeof AUTHORIZED_ASSETS_TYPES_ICONS;

/**
 * Convert entity type to authorized assets type
 * @param type
 * @returns
 */
export const getAuthorizedAssetsTypeFromEntityType = (type: DatasourceDto.entityType) => {
  switch (type) {
    case DatasourceDto.entityType.DATASET:
      return AssetsTypesEnum.TABLE_AND_VIEW;
    case DatasourceDto.entityType.DASHBOARD:
      return AssetsTypesEnum.DASHBOARD;
    case DatasourceDto.entityType.DAG:
    case DatasourceDto.entityType.TRANSFORMATION:
      return AssetsTypesEnum.PIPELINE;
    case DatasourceDto.entityType.DECLARED_ASSET:
      return AssetsTypesEnum.DECLARATIVE_ASSET;
    default:
      return AssetsTypesEnum.DECLARATIVE_ASSET;
  }
};

/**
 * Convert custom metadata type to icon
 * @param type
 */
export const getIconFromCustomMetadataType = (type: CreateCustomMetadataRequestDto.type) => CUSTOM_METADATA_TYPES_ICONS[type] || 'icon-tag';

/**
 * Convert custom metadata asset type to icon
 * @param type
 */
export const getIconFromCustomMetadataAssetType = (type: AuthorizedAssetsTypesIconsEnum) => AUTHORIZED_ASSETS_TYPES_ICONS[type] || 'icon-tag';
